export const tsysCanadaDefaults = {
  terminalID: '',
  locationID: '',
  printReceipt: '2',
  authKey: '',
};

export const tsysCanadaFields = {
  terminalID: {
    id: 'terminalID',
    title: 'Terminal ID',
    type: 'text',
    validate: (val?: string) => {
      if (val?.length) {
        return val?.match(/[^\da-zA-Z.-]/g)?.length
          ? 'Invalid terminal ID.'
          : null;
      }
      return 'Terminal ID is required.';
    },
  },
  locationID: {
    id: 'locationID',
    title: 'Location ID (X-WB ID)',
    type: 'text',
    validate: (val?: string) => {
      if (val?.length) {
        return val?.match(/[^\d]/g)?.length ? 'Invalid location ID' : null;
      }
      return 'Location ID is required.';
    },
  },
  authKey: {
    id: 'authKey',
    title: 'Auth Key',
    type: 'password',
    validate: (val?: string) => (val?.length ? null : 'Auth key is required.'),
  },
  printReceipt: {
    id: 'printReceipt',
    title: 'Print receipt for',
    type: 'select',
    validate: () => {},
    options: [
      { name: 'Merchant and Customer', value: '1' },
      { name: 'Merchant', value: '0' },
      { name: 'None', value: '2' },
    ],
  },
};
